/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacetGroupModel } from './FacetGroupModel';
import {
    FacetGroupModelFromJSON,
    FacetGroupModelFromJSONTyped,
    FacetGroupModelToJSON,
} from './FacetGroupModel';
import type { FacetModel } from './FacetModel';
import {
    FacetModelFromJSON,
    FacetModelFromJSONTyped,
    FacetModelToJSON,
} from './FacetModel';
import type { ProductCardModel } from './ProductCardModel';
import {
    ProductCardModelFromJSON,
    ProductCardModelFromJSONTyped,
    ProductCardModelToJSON,
} from './ProductCardModel';
import type { SortingModel } from './SortingModel';
import {
    SortingModelFromJSON,
    SortingModelFromJSONTyped,
    SortingModelToJSON,
} from './SortingModel';

/**
 * 
 * @export
 * @interface ProductCardModelSpecificationGroupSearchProductResponse
 */
export interface ProductCardModelSpecificationGroupSearchProductResponse {
    /**
     * 
     * @type {Array<ProductCardModel>}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly results?: Array<ProductCardModel>;
    /**
     * 
     * @type {number}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly startingFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly totalResults?: number;
    /**
     * 
     * @type {Array<FacetModel>}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly facets?: Array<FacetModel>;
    /**
     * 
     * @type {Array<SortingModel>}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly sortings?: Array<SortingModel>;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    readonly searchTerms?: string;
    /**
     * 
     * @type {{ [key: string]: Array<string> | undefined | null; }}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    foundSpecificationGroups?: { [key: string]: Array<string> | undefined | null; };
    /**
     * 
     * @type {Array<FacetGroupModel>}
     * @memberof ProductCardModelSpecificationGroupSearchProductResponse
     */
    facetGroups?: Array<FacetGroupModel>;
}

/**
 * Check if a given object implements the ProductCardModelSpecificationGroupSearchProductResponse interface.
 */
export function instanceOfProductCardModelSpecificationGroupSearchProductResponse(value: object): boolean {
    return true;
}

export function ProductCardModelSpecificationGroupSearchProductResponseFromJSON(json: any): ProductCardModelSpecificationGroupSearchProductResponse {
    return ProductCardModelSpecificationGroupSearchProductResponseFromJSONTyped(json, false);
}

export function ProductCardModelSpecificationGroupSearchProductResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCardModelSpecificationGroupSearchProductResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(ProductCardModelFromJSON)),
        'startingFrom': json['startingFrom'] == null ? undefined : json['startingFrom'],
        'totalResults': json['totalResults'] == null ? undefined : json['totalResults'],
        'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(FacetModelFromJSON)),
        'sortings': json['sortings'] == null ? undefined : ((json['sortings'] as Array<any>).map(SortingModelFromJSON)),
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'foundSpecificationGroups': json['foundSpecificationGroups'] == null ? undefined : json['foundSpecificationGroups'],
        'facetGroups': json['facetGroups'] == null ? undefined : ((json['facetGroups'] as Array<any>).map(FacetGroupModelFromJSON)),
    };
}

export function ProductCardModelSpecificationGroupSearchProductResponseToJSON(value?: Omit<ProductCardModelSpecificationGroupSearchProductResponse, 'results'|'startingFrom'|'totalResults'|'facets'|'sortings'|'searchTerms'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'foundSpecificationGroups': value['foundSpecificationGroups'],
        'facetGroups': value['facetGroups'] == null ? undefined : ((value['facetGroups'] as Array<any>).map(FacetGroupModelToJSON)),
    };
}

